import { TransactionRepository } from "../../../../data/repository/transactions/TransactionRepository";
import { ResponseState, State } from "../../../model/ResponseState";
import { Transaction } from "../../../model/Transaction";

export interface GetAllTransactionsUseCase {
  invoke: (
    skip?: number,
    limit?: number
  ) => Promise<ResponseState<Array<Transaction>>>;
}

export class GetAllTransactionsUseCaseImpl
  implements GetAllTransactionsUseCase
{
  private repository: TransactionRepository;

  constructor(repository: TransactionRepository) {
    this.repository = repository;
  }

  async invoke(
    skip?: number,
    limit?: number
  ): Promise<ResponseState<Array<Transaction>>> {
    try {
      let response = await this.repository.getAll(skip, limit);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
